import { render, staticRenderFns } from "./AdvisorProjects.vue?vue&type=template&id=3c2039a1&scoped=true&"
import script from "./AdvisorProjects.vue?vue&type=script&lang=js&"
export * from "./AdvisorProjects.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorProjects.vue?vue&type=style&index=0&id=3c2039a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2039a1",
  null
  
)

export default component.exports